import { RecurringOrdersService } from './../../shared/services/recurring-orders.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Address } from '@classes/address';
import { Client } from '@classes/client';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { Pagination } from '@classes/pagination/pagination';
import { RecurringOrder } from '@classes/recurring-order/recurring-order';
import { Site } from '@classes/site';
import { User } from '@classes/user/user';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SitesService } from '@services/sites.service';
import { ClientsService } from '@services/clients.service';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { AddressesService } from '@services/addresses.service';
import { UsersService } from '@services/users.service';
import { AuthService } from '@services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { RoleName } from '@enums/role-name.enum';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-recurring-orders-list',
  templateUrl: './recurring-orders-list.component.html',
  styleUrls: ['./recurring-orders-list.component.scss'],
})
export class RecurringOrdersListComponent
  extends DatatableBaseComponent
  implements OnInit
{
  @Output() clearOneFilterEvent = new EventEmitter<any>();

  orders: RecurringOrder[];
  indexToRemove = null;

  displayedColumns: string[] = [];
  displayedColumnsMenu: any[] = [
    { editable: true, name: 'cronDescription', selected: true, visible: false },
    { editable: true, name: 'urgency', selected: true, visible: false },
    { editable: true, name: 'sender', selected: true, visible: false },
    { editable: true, name: 'receivers', selected: true, visible: false },
    { editable: true, name: 'client', selected: true, visible: false },
    { editable: true, name: 'site', selected: true, visible: false },
    { editable: true, name: 'createdOn', selected: true, visible: false },
    { editable: true, name: 'startTime', selected: true, visible: false },
    { editable: false, name: 'actions', selected: true, visible: false },
  ];

  dataSource: MatTableDataSource<RecurringOrder>;

  // filterValue: string;
  filterValue = null;
  pagination: Pagination;
  sortValue: string;

  dispatchers: User[];
  clients: Client[];
  sites: Site[];
  urgencies: DictionaryValue[];
  senders: Address[];
  receivers: Address[];

  isLoadingFilterForm: boolean;

  globalFilter = '';

  filterForm = new UntypedFormGroup({
    identifier: new UntypedFormControl(),
    dispatcher: new UntypedFormControl(),
    client: new UntypedFormControl(),
    site: new UntypedFormControl(),
    urgency: new UntypedFormControl(),
    sender: new UntypedFormControl(),
    receiver: new UntypedFormControl(),
  });

  filteredValues = {
    identifier: '',
    dispatcher: '',
    client: '',
    site: '',
    urgency: '',
    sender: '',
    receiver: '',
  };

  isDispatcher: boolean;
  isAdmin: boolean;

  initialSelection = [];

  dateNow: Date;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private recurringOrdersSrv: RecurringOrdersService,
    private router: Router,
    private route: ActivatedRoute,
    private sitesSrv: SitesService,
    private clientsSrv: ClientsService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private authSrv: AuthService,
    public dialog: MatDialog,
    private _userService: UsersService,
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    this.dateNow = new Date();

    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin;

    if (this._userService.globalSelectedClient) {
      this.filterForm.patchValue({
        client: this._userService.globalSelectedClient.name,
      });
      this.filterValue = this.filterForm.value;
    }

    super.ngOnInit();
    this.checkIfColumnsInStorage();
    this.initSubscriptions();
  }

  checkIfColumnsInStorage(): void {
    if (localStorage.getItem('displayedColumnsMenuRecurring')) {
      this.displayedColumnsMenu = JSON.parse(
        localStorage.getItem('displayedColumnsMenuRecurring'),
      );
    } else {
      this.displayedColumnsMenu = [
        { editable: true, name: 'urgency', selected: true, visible: false },
        {
          editable: true,
          name: 'cronDescription',
          selected: true,
          visible: false,
        },
        { editable: true, name: 'sender', selected: true, visible: false },
        { editable: true, name: 'receivers', selected: true, visible: false },
        { editable: true, name: 'client', selected: true, visible: false },
        { editable: true, name: 'site', selected: true, visible: false },
        { editable: true, name: 'createdOn', selected: true, visible: false },
        { editable: true, name: 'startTime', selected: true, visible: false },
        { editable: false, name: 'actions', selected: true, visible: false },
      ];
    }
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].name === obj.name) {
        this.indexToRemove = i;
        return true;
      }
    }

    return false;
  }

  onFilter(): void {
    const formValue = this.filterForm.value;

    this.filterValue = formValue;
    this.getList();
  }

  clearFilters(): void {
    this.filterForm.reset();
    this.filterValue = null;
    this.getList();
  }

  filterEnter(event: Event, column) {
    this.filterValue = this.filterForm.value;
    this.getList();
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.pagination.pageNumber = pageEvent.pageIndex + 1;
    this.getList();
  }

  onSortChanged(sortEvent: Sort): void {
    let direction = '';

    if (sortEvent.direction === 'asc') {
      direction = '';
    } else if (sortEvent.direction === 'desc') {
      direction = '-';
    }
    if (sortEvent.direction === '') {
      this.sortValue = null;
    } else {
      this.sortValue = ` ${direction}${sortEvent.active}`;
    }

    this.getList();
  }

  onSelectOrder(id: string): void {
    this.router.navigate([`../${id}`], { relativeTo: this.route });
  }

  getList(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      this.pagination.pageNumber,
    );

    this.recurringOrdersSrv.getList(newRequest);
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.orders);
    this.dataSource.sort = this.sort;
  }

  private initSubscriptions(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      1,
    );
    this.recurringOrdersSrv.getList(newRequest);

    this.addSubscription(
      this.recurringOrdersSrv.recurringOrdersListChanged.subscribe((orders) => {
        this.orders = orders;
        this.setDisplayedColumns();
        this.initTable();
      }),
    );

    this.addSubscription(
      this._userService.globalSelectedClientSubject.subscribe((client) => {
        this.filterForm.patchValue({
          client: client ? client.name : null,
        });
        this.filterValue = this.filterForm.value;
        this.getList();
      }),
    );

    this.isLoadingFilterForm = true;

    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getList().subscribe((sitesFromSrv) => {
        this.sites = sitesFromSrv;
        resolve(true);
      });
    });

    const clientsPromise = new Promise((resolve, reject) => {
      this.clientsSrv.getList().subscribe((clientsFromSrv) => {
        this.clients = clientsFromSrv;
        resolve(true);
      });
    });

    const urgencyLevelsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv.getUrgencyList().subscribe((urgencyLevelsFromSrv) => {
        this.urgencies = urgencyLevelsFromSrv;
        resolve(true);
      });
    });

    const addressPromise = new Promise((resolve, reject) => {
      this.addressesSrv.getList().subscribe((addressessFromSrv) => {
        this.senders = addressessFromSrv.filter((address) => address.isSender);
        this.receivers = addressessFromSrv.filter(
          (address) => address.isReceiver,
        );
        resolve(true);
      });
    });

    Promise.all([
      sitesPromise,
      clientsPromise,
      urgencyLevelsPromise,
      addressPromise,
    ]).then(() => {
      this.isLoadingFilterForm = false;
    });

    this.addSubscription(
      this.recurringOrdersSrv.paginationSubject.subscribe((pagination) => {
        this.pagination = pagination;
      }),
    );
  }

  delete(order: RecurringOrder): void {
    const confirmation = confirm(
      'Êtes-vous certain de vouloir supprimer cet abonnement ?',
    );
    if (confirmation) {
      this.recurringOrdersSrv.delete(order.id).subscribe(() => {
        this.uiSrv.showSnackbar('Abonnement supprimé avec succès', false);
      });
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    // Swap the elements around
    moveItemInArray(
      this.displayedColumnsMenu,
      event.previousIndex,
      event.currentIndex,
    );
    localStorage.setItem(
      'displayedColumnsMenuRecurring',
      JSON.stringify(this.displayedColumnsMenu),
    );
    this.setDisplayedColumns();
  }

  onSelectMenu(event, name) {
    this.displayedColumnsMenu.find((f) => f.name === name).selected =
      event.checked;
    localStorage.setItem(
      'displayedColumnsMenuRecurring',
      JSON.stringify(this.displayedColumnsMenu),
    );
    this.setDisplayedColumns();
  }

  private setDisplayedColumns(): void {
    this.displayedColumns = this.displayedColumnsMenu
      .filter((f) => (f || {}).selected)
      .map((m) => m.name);
  }

  getControl(control: string): UntypedFormControl {
    return this.filterForm.get(control) as UntypedFormControl;
  }
}
